export default class Name {
	constructor(firstName, lastName) {
		this._firstName = firstName || '';
		this._lastName = lastName || '';
	}

	getFirstName() {
		if(this._firstName.length > 1){
			return this._firstName.charAt(0).toUpperCase() + this._firstName.slice(1);
		}
		return this._firstName;
	}

	getLastName() {
		return this._lastName.toUpperCase();
	}

	getFullName() {
		if (this._lastName && this._firstName) {
			return `${this._firstName} ${this._lastName}`;
		}
		return this._firstName || this._lastName;
	}

	toString() {
		return this.getFullName();
	}
}
